// 免费吃瓜 · 单页展示数据（静态占位，不接接口）

export const heroMeta = [
  { icon: "ri-flashlight-line", text: "无门槛点开" },
  { icon: "ri-vip-diamond-line", text: "不设会员" },
  { icon: "ri-money-cny-circle-line", text: "零元直接看" },
  { icon: "ri-shield-user-line", text: "免注册" },
];

export const steps = [
  {
    icon: "ri-cursor-line",
    step: "01",
    title: "点开即看",
    desc: "不用付费也不用开会员，看到感兴趣的直接点进去，素材当场就能看。",
  },
  {
    icon: "ri-list-check-3",
    step: "02",
    title: "按线跟到底",
    desc: "整理好的截图、时间线、后续回应按顺序排好，从瓜的源头看到收尾。",
  },
  {
    icon: "ri-history-line",
    step: "03",
    title: "随时回来看",
    desc: "不收藏也能随时回来看，真正不花钱、不注册，满足零成本围观需求。",
  },
];

export const ticker = [
  "新瓜已上线",
  "又更新一条回应",
  "截图已补全",
  "时间线推进中",
  "后续回应已归档",
  "素材已整理",
];

// 今日吃瓜速览
export const hotFeatured = {
  tag: "热度爆表",
  title: "顶流恋情被拍实锤？完整时间线零元直接看",
  text: "从第一张街拍到双方团队回应，截图、路透与时间点全部按顺序排好。付费平台还没发完全，这里已经能从前往后看个明白。",
  img: "https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20scene%20of%20two%20watermelon%20slices%20and%20popcorn%20beside%20a%20smartphone%20screen%20glowing%20softly%2C%20cream%20beige%20background%2C%20soft%20natural%20window%20light%2C%20casual%20gossip%20viewing%20mood%2C%20editorial%20photography%2C%20high%20detail%2C%20cozy%20and%20clean&width=1200&height=760&seq=gua-hero-main&orientation=landscape",
  time: "今天 14:30 更新",
  views: "126万围观",
};

export const hotList = [
  {
    tag: "持续跟进",
    title: "选秀决赛名次争议：投票数据逐帧复盘",
    time: "2 小时前",
    views: "48.2万围观",
  },
  {
    tag: "后续回应",
    title: "直播翻车主播深夜发声，三小时回应全文整理",
    time: "今天 09:12",
    views: "91.7万围观",
  },
  {
    tag: "截图实锤",
    title: "剧组档期冲突内幕，聊天截图逐张标注重点",
    time: "昨天 22:40",
    views: "37.9万围观",
  },
  {
    tag: "反转新瓜",
    title: "代言解约后续：品牌方声明与艺人时间线对照",
    time: "昨天 18:05",
    views: "63.4万围观",
  },
];

// 正在持续跟进
export const followUps = [
  {
    time: "08-31",
    title: "首波截图流出",
    body: "第一组同框截图与定位信息被整理出来，围观页已上线。",
    mark: "起点",
  },
  {
    time: "09-01",
    title: "双方首次回应",
    body: "相关方接连发声，原文与重点已标注，无需会员即可点开。",
    mark: "回应",
  },
  {
    time: "09-03",
    title: "时间线补全",
    body: "将爆料、澄清、二次回应按时间排序，前后逻辑一目了然。",
    mark: "整理",
  },
  {
    time: "09-05",
    title: "第三方佐证跟进",
    body: "新增同场直播切片与后台截图佐证，持续更新中。",
    mark: "新瓜",
  },
];

// 题材频道
export const channels = [
  { icon: "ri-heart-pulse-line", name: "恋情情变", count: "842 则", desc: "街拍、实锤与澄清按线归整" },
  { icon: "ri-vip-crown-line", name: "节目内幕", count: "517 则", desc: "票数、剪辑与档期争议复盘" },
  { icon: "ri-store-3-line", name: "直播带货", count: "639 则", desc: "翻车现场与售后回应汇总" },
  { icon: "ri-mic-2-line", name: "明星发声", count: "428 则", desc: "声明原文逐句标注重点" },
  { icon: "ri-film-line", name: "剧组八卦", count: "356 则", desc: "路透、排场与人员变动" },
  { icon: "ri-stack-line", name: "冷门旧瓜", count: "203 则", desc: "被翻出来的老瓜新看" },
];

// 热门专题精选（大小卡混排）
export const topics = [
  {
    big: true,
    tag: "本周焦点",
    title: "一场发布会引发的连环瓜",
    text: "从一句被断章取义的话，到片方、平台、合作方轮流发声。截图与直播切片按秒对齐，错过的环节回来补上即可。",
    img: "https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20photography%20of%20popcorn%20and%20melting%20ice%20cream%20on%20a%20cream%20plate%2C%20beige%20studio%20background%2C%20soft%20window%20light%2C%20gossip%20watching%20scene%2C%20cozy%20clean%20composition%2C%20high%20detail&width=1200&height=760&seq=gua-topic-01&orientation=landscape",
    time: "近 7 天热度第一",
  },
  {
    big: false,
    tag: "收视瓜",
    title: "黄金档收视对打，谁在买通稿",
    img: "https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20photo%20of%20an%20old%20tv%20remote%20and%20coffee%20cup%20on%20cream%20table%2C%20beige%20background%2C%20soft%20light%2C%20casual%20entertainment%20media%20topic%2C%20clean%20cozy%20composition&width=760&height=520&seq=gua-topic-02&orientation=landscape",
  },
  {
    big: false,
    tag: "合同瓜",
    title: "解约条款逐字读，违约金藏着哪些坑",
    img: "https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20photo%20of%20stacked%20documents%20and%20pen%20with%20sealing%20stamp%20on%20cream%20desk%2C%20beige%20background%2C%20soft%20light%2C%20contract%20analysis%20mood%2C%20clean%20composition&width=760&height=520&seq=gua-topic-03&orientation=landscape",
  },
];

export const reasons = [
  { icon: "ri-eye-off-line", title: "不看广告也不设会员", desc: "素材原样呈现，想看哪一段直接点，不拦在半路。" },
  { icon: "ri-gallery-view-2", title: "截图与时间线对齐", desc: "每一张截图都挂在对应的时间点上，反转看得清楚。" },
  { icon: "ri-file-history-line", title: "后续回应不漏更", desc: "从爆料到澄清一路跟到底，回来后也能接着往下看。" },
];

export const faqs = [
  {
    q: "不设会员，真的点开就能看吗？",
    a: "是的。这里的素材免费吃瓜、零元直接看，不用付费也不用开会员，也不用先登录。想看哪则点哪则，素材原样摆在页面里。",
  },
  {
    q: "截图、时间线、后续回应会一直更新吗？",
    a: "正在持续跟进的瓜会按顺序补充新截图与新的后续回应，时间线也会往前推进。错过更新回来后接着往下看即可，不需要收藏。",
  },
  {
    q: "需要下载 App 或安装什么吗？",
    a: "不需要。打开网页就能围观，浏览器里直接看，不注册、不花钱、不占额外空间，适合随时随地的零成本围观。",
  },
  {
    q: "同一则瓜，我能不能从最开头看起？",
    a: "能。每则素材都按时间先后整理好了起点与进展，想完整复盘可以直接从第一条开始顺序看到后续回应。",
  },
];

export const footerChunks = [
  { head: "围观指引", links: ["无门槛点开", "零元直接看", "不设会员说明", "随时回看帮助"] },
  { head: "内容分类", links: ["恋情情变", "节目内幕", "直播带货", "剧组八卦"] },
  { head: "关于站点", links: ["素材来源说明", "免费吃瓜承诺", "联系方式", "常见围观问题"] },
];